import httpInstances from '@/api/axiosInstance';

const downloadFileFromDatalake = async (fileId: string) => {
  return httpInstances.axiosInternalInstance
    .get(`/proxy/datalake/file/${fileId}`, {
      responseType: 'blob'
    })
    .then(response => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 404) {
        throw new Error('File not found');
      }
    });
};

export default downloadFileFromDatalake;
